import { render, staticRenderFns } from "./WishlistMenu.vue?vue&type=template&id=be4ac368&"
import script from "./WishlistMenu.vue?vue&type=script&lang=js&"
export * from "./WishlistMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be4ac368')) {
      api.createRecord('be4ac368', component.options)
    } else {
      api.reload('be4ac368', component.options)
    }
    module.hot.accept("./WishlistMenu.vue?vue&type=template&id=be4ac368&", function () {
      api.rerender('be4ac368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/headers/shared/WishlistMenu.vue"
export default component.exports